import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useOnboardingChecklist } from "@/hooks/use-api";
import { SetupWizard } from "@/components/setup/setup-wizard";

export default function SetupPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data: checklist, isLoading } = useOnboardingChecklist(user?.tenantId);

  const handleSkip = () => {
    localStorage.setItem(`onboarding_skipped_${user?.tenantId ?? "unknown"}`, "true");
    navigate("/app");
  };

  const handleComplete = () => {
    navigate("/app");
  };

  return (
    <SetupWizard
      checklist={checklist ?? null}
      isLoading={isLoading}
      onSkip={handleSkip}
      onComplete={handleComplete}
    />
  );
}
